export { SERVICE_NAME as DXDASHBOARD_SERVICE_NAME, DXDashboardService, DXDashboardFilter } from './dxdashboard.service'
